import React, { Component } from "react"
import { Redirect } from "react-router-dom";
import Button from '@react/react-spectrum/Button';
import Square from "../Imgs/Square";
import Uploading from "./Uploading";
import uploadimg from "../Imgs/upload_icon.svg";
import landing from "../Imgs/landing.png";
import Header from "./headers/Header";
import { addToast, Toast } from '@react/react-spectrum/Toast'
// images - used full and thumb images same: 
import sample1 from "../Imgs/sample1.jpg";
import sample3 from "../Imgs/sample2.jpg";
import sample2 from "../Imgs/sample3.jpg";
import sample4 from "../Imgs/sample4.jpg";

import sampleFull1 from "../Imgs/QA_V2.jpg";
import sampleFull3 from "../Imgs/QA_V1.jpg";
import sampleFull2 from "../Imgs/QA_V3.jpg";
import sampleFull4 from "../Imgs/QA_V4.jpg";

import CaptureAnalytics from '../analytics/CaptureAnalytics';
import './ActionCard.scss';
import { withRouter } from "react-router-dom";
import GlobalUtil from '../utils/GlobalUtil';

class ActionCard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loaded: false,
            image: "",
            redirect: null,
            dragging: false,
        }
        this.titleDesc = { pattern: "geometric" }
        this.images = [sample1, sample2, sample3, sample4];
        this.full = [sampleFull1, sampleFull2, sampleFull3, sampleFull4];
        this.dragCounter=0;
        this.toastRef = React.createRef();
    }
    preloadImages() {
		const sampleImages = this.full;
            sampleImages.map((url) => {
			const img = new Image();
			img.src = url;
			return img;
		});
	}
    componentDidMount() {
        GlobalUtil.sessionStorageClear();
        window.adobeid.api_parameters.authorize.redirect_uri = window.location.href;
        let element = document.querySelector("html");
        if(element) {
            element.classList.remove("noUrlScroll");
            element.classList.add("noUrlScroll");
        }
        element = document.querySelector("#root");
        if (element) {
            element.classList.add("pattern-quick-actions");
        }
        this.preloadImages();
        this.sendActivationAnalytic('render');
        setTimeout(()=>window.scrollTo(0, 0),0);
    }
    componentWillUnmount() {
        let element = document.querySelector("html");
        if(element) {
            element.classList.remove("noUrlScroll");
        }
        element = document.querySelector("#root");
        if (element) {
            element.classList.remove("pattern-quick-actions");
        }
    }
    handleUpload = (e) => {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0];
            let src = URL.createObjectURL(img);
            this.setState({
                image: src,
                loaded: true,
                redirect: `/quick-actions/${this.props.title}/make`
            });
        }
    }
    handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter++;
        this.setState({dragging: true});
    };
    handleDragleave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter--;
        if (this.dragCounter === 0) {
            this.setState({dragging: false})
        }
    };
    handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            let type = e.dataTransfer.files[0].type;
            if (type === "image/jpg" || type === "image/png" || type === "image/jpeg") {
                let img = e.dataTransfer.files[0];
                let src = URL.createObjectURL(img);
                this.setState({
                    image: src,
                    loaded: true,
                    redirect: `/quick-actions/${this.props.title}/make`
                });
            }
            else {
                addToast(
                    <Toast className="fileNotSupported" closable variant="error">
                      File(s) not supported
                    </Toast>,3000,
                  );
            }
        }
        this.dragCounter = 0 ;
        this.setState({dragging: false})
    };
    imgSqs = () => {
        return this.images.map((img, i) => <Square key={i} i={i} size="med" img={img} onClick={this.handleClick} />)
    }
    sendActivationAnalytic(type: string, testValue?: string) {
		const captureAnalytics = new CaptureAnalytics(window.ENV);
        captureAnalytics.initAnalytics();
        let eventObj;
		switch (type) {
			case 'thumbnailClick':
                eventObj = {
                    workflow: 'Landing Page',
                    subCategory: 'Use Sample',
                    type: 'click',
                    subType: '',
                    contentName: 'sample' + testValue
                };
                break;
            case 'addPhotoClick':
                eventObj = {
                    workflow: 'Landing Page',
                    subCategory: 'Upload Photo',
                    type: 'click',
                    subType: 'start',
                };
                break; 
            case 'render':
                eventObj = {
                    workflow: 'Landing Page',
                    setUIFilter: window.matchMedia("(orientation: portrait)").matches ? 'Portrait' : 'Landscape',
                    subCategory: 'Browser',
                    type: 'render',
                    subType: 'referrer',
                    
                };
                break;  
        }
        captureAnalytics.genericAnalyticEvent(eventObj);
	}
    handleClick = (e) => {
        let i = e.target.id;
        this.sendActivationAnalytic('thumbnailClick',i);
        this.setState({
            image: this.full[i],
            loaded: true,
            redirect: `/quick-actions/${this.props.title}/make`
        });
    }
    actionCard = () => {
        const { title } = this.props
        return (
            <>
                <div className="actionGrid">
                    <div className="makePatterns">
                        <Header title={title} pagename="action" />
                        <div className="actionImg2"></div>
                        <div className="actionInside">
                            {/* <div className ="borderImg"></div> */}
                            <div className={this.state.dragging ? "actionInsideUpload dragging": "actionInsideUpload"} onDragEnter={this.handleDragEnter} onDragLeave={this.handleDragleave} onDragOver={this.handleDragOver} onDrop={this.handleDrop}>
                                <img className="uploadImg" src={uploadimg}></img>
                                <p className="dragDropText">Create {this.titleDesc[title] ? this.titleDesc[title] : null} {title}s </p>
                                <p className="dragDropdesc">Drag and drop a jpg, jpeg, or png to make a {title}.</p>
                                <input type="file" name="imgUpload" ref="file" className="inputfile" onChange={this.handleUpload}
                                    accept=".png,.jpg"
                                />
                                <Button variant="cta" onClick={() => {this.sendActivationAnalytic('addPhotoClick');this.refs.file.click();}}>Add a photo</Button>
                            </div>
                            <div className="actionInside2">
                                <p>Or try one of these</p>
                                <div className="sqPadding">
                                    {this.imgSqs()}
                                </div>
                                <h5 className="terms">By using the source, you agree to the <a href="http://www.adobe.com/go/terms" target="_blank">Adobe Terms of Use</a> and <a href="https://www.adobe.com/privacy/policy.html" target="_blank">Privacy Policy </a></h5>
                            </div>
                        </div>
                    </div>
                    <div className="actionImg">
                    </div>
                </div>
                <div ref={this.toastRef}></div>
            </>
        )
    }
    render() {
        const { loaded, image, redirect } = this.state
        const { title } = this.props;
        
        return (
            <>
                {loaded ?
                    <Redirect push to={{
                        pathname: redirect,
                        state: {
                            file: image,
                            action: title
                        }
                    }} />:this.actionCard()}
            </>
        )
    }
}

export default withRouter(ActionCard);